<template>
	<div ref="birthBarthCom">
		<div class="flex-bar">
			<span class="icon-goback" @click="birthShow"></span>
			<div class="flex-title">
				<span class="vt-middle">购物车-生日牌选择</span>
			</div>
			<span class="flex-right">
				<span class="edite" @click="saveBirthText">保存</span>
			</span>
		</div>
		<div class="birth-branch-sec">
			<div class="branch-title">生日牌类型选择</div>
			<ul class="branch-list">
				<li>
					<label for="none">
						<span class="radio-group">
							<input id="none" type="radio" class="input-radio" v-model="branchText" value="无">
							<span class="icon-radio"></span>
						</span>
						无
					</label>
				</li>
				<li>
					<label for="Bfirst">
						<span class="radio-group">
							<input id="Bfirst" type="radio" class="input-radio" v-model="branchText" value="生日快乐">
							<span class="icon-radio"></span>
						</span>生日快乐
					</label>
				</li>
				<li>
					<label for="Bsecond">
						<span class="radio-group">
							<input id="Bsecond" type="radio" class="input-radio" v-model="branchText" value="Happy Birthday">
							<span class="icon-radio"></span>
						</span>Happy Birthday
					</label>
				</li>
				<li>
					<label for="Bthird">
						<span class="radio-group">
							<input id="Bthird" type="radio" class="input-radio" v-model="branchText" value="节日快乐">
							<span class="icon-radio"></span>
						</span>节日快乐
					</label>
				</li>
				<li>
					<label for="Bfour">
						<span class="radio-group">
							<input id="Bfour" type="radio" class="input-radio" v-model="branchText" value="新年快乐">
							<span class="icon-radio"></span>
						</span>新年快乐
					</label>

				</li>
				<li>
					<label for="Bfive">
						<span class="radio-group">
							<input id="Bfive" type="radio" class="input-radio" v-model="branchText" value="Happy New Year">
							<span class="icon-radio"></span>
						</span>Happy New Year
					</label>
				</li>
				<li>
					<label for="Bsix">
						<span class="radio-group">
							<input id="Bsix" type="radio" class="input-radio" v-model="branchText"   value="0" >
							<span class="icon-radio"></span>
						</span>其它
					</label>
				</li>
				<li>
					<input type="text" v-model="otherBranchText" ref="inputText" maxlength="16" class="branch-other" :class="{'error': error==true}" placeholder="最多填写8字中文或16字英文">
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import { mapState } from 'vuex'
	
	export default {
		props: [],
		data() {
			return {
				branchText: '无',
				otherBranchText: '',
				error: false
			}
		},
		mounted(){
			let self = this;
			const bodyHeight = document.body.clientHeight;
			window.onresize  = function(){
			
				var target = self.$refs.birthBarthCom;
				if(bodyHeight > document.body.clientHeight ){
					target.style.marginTop = '-200px'
				}else {
					target.style.marginTop = 'auto'	
				}

			}
		},
		methods:{
			init(){
				this.branchText = '无',
				this.otherBranchText =  '',
				this.error = false;
			},
			birthShow(){
				this.$emit('birthShow');
			},
			saveBirthText(){
				if(this.branchText == '0' && this.otherBranchText == ''){
					this.error = true;
					return false;
				}
				if(this.branchText == '0'){
					this.$emit('saveBirthText',this.otherBranchText);
				}else {
					this.$emit('saveBirthText',this.branchText);
				}
				this.$emit('birthShow');
				this.init();
			}
		}
	}
</script>

<style lang="scss">
	@import '../../../assets/css/mixin';
	.flex-bar {
		padding: 0 pxToRem(30px);
		display: flex;
		justify-content: space-around;
		height: pxToRem(100px);
		line-height: pxToRem(100px);
		border-bottom: 1px solid #eee;
	}

	.flex-title {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		background-color: rgba(255,255,255,0.90);
	}
	.edite {
		display: inline-block;
		width: pxToRem(60px);
		color: #666;
	}

	.birth-branch-sec {
		padding: pxToRem(40px);
		width: 100%;

		.branch-title {
			font-size: pxToRem(20px);
			color: #666;
		}

		.branch-list {
			margin-top: 20px;
			margin-left: pxToRem(60px);
			li {
				// line-height: pxToRem(84px);
				line-height: 1;
				margin-top: pxToRem(60px);

				&:last-of-type {
					margin-top: pxToRem(20px);
					padding-left: pxToRem(30px);
				}
			}
		}

		.branch-other {
			margin-top: pxToRem(10px);
			padding: 0 pxToRem(20px);
			width: 100%;
			border: 1px solid #666666;
			line-height: pxToRem(66px);

			&.error {
				border-color: #D8331D;
			}

		}
	}

	.input-radio {
		-webkit-appearance: radio;
		margin-right: pxToRem(10px);
	}

	
</style>


// WEBPACK FOOTER //
// birthBrand.vue?7f69fc40